<template>
    <v-layout column>
        <span class="title text-xs-left mb-2">Teachers</span>
        <v-divider class="grey"></v-divider>
        <br>
        <v-dialog v-model="deleteDialog" max-width="350" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    Delete Credit Note
                </v-card-title>
                <v-card-text class="text-xs-left">
                    Are you sure you want to delete this record?
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="error" block dark flat="flat" @click="deleteDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="deleteRecord()">Confirm</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="createClassroomDialog" max-width="850" persistent>
            <v-card>
                <v-card-title class="grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    <span class="subheading"> Create Classroom </span>
                    <v-btn class="close" icon right flat="flat" @click="createClassroomDialog = false"><v-icon small >close</v-icon></v-btn>
                </v-card-title>
                <v-flex layout row wrap pt-2 pb-2 mb-4 text-xs-left text-sm-left text-md-center text-lg-center>

                    <v-flex layout row wrap pt-2 pb-2>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.name" type="text" name="name" label="Name" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.description" type="text" name="description" label="Description" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.alias" type="text" name="alias" label="Classroom ID" box
                            ></v-text-field>
                        </v-flex>


                        <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-text-field-->
                        <!--v-model="form.password" type="text" name="password" label="Password" box-->
                        <!--&gt;</v-text-field>-->
                        <!--</v-flex>-->

                        <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-autocomplete :items="$store.getters.getUserTypes.sort()" label="User Role"-->
                        <!--item-text="name" item-value="id" placeholder=""-->
                        <!--v-model="form.role" box >-->

                        <!--</v-autocomplete>-->
                        <!--</v-flex>-->
                    </v-flex>

                </v-flex>
                <v-card-actions>
                    <v-flex xs12 layout row wrap>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="error" block dark flat="flat" @click="createClassroomDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="primary" block dark flat="flat" v-on:click="createCourse()">Ok</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-card>
            <v-toolbar flat dense class="primary" dark>
                <v-text-field xs6 v-model="searchText" prepend-icon="search" label="Search" color="white" single-line clearable hide-details></v-text-field>
                <v-spacer></v-spacer>
                <!--<v-btn  v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="createClassroomDialog = true"><v-icon class="pr-3">add</v-icon>Create Classroom</v-btn>-->
                <v-btn color="primary" dark class="mb-2" icon @click="update()"><v-icon>refresh</v-icon></v-btn>
            </v-toolbar>

            <v-data-table v-if="$store.state.classrooms.teacher.headers" :headers="$store.state.classrooms.teacher.headers"
                          :items="allItems" :loading="loading" :search="searchText" class="elevation-2" :total-items="total"
                          :rows-per-page-items="rows" :pagination.sync="pagination">
                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">
                        <td v-for="(header, index) in $store.state.classrooms.teacher.headers" :key="index" :class="'text-xs-'+header.align">
                            <span v-if="header.value != 'actions'">{{ props.item[header.value] }}</span>
                            <span v-else v-show="$store.state.auth.user.role!=4">
                <v-btn icon class="grey lighten-4" @click="edit(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                                <!--<v-btn icon class="grey lighten-4" @click="deletePrompt(props.item)">-->
                                <!--<v-icon color="accent">delete</v-icon>-->
                                <!--</v-btn>-->
              </span>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-card>
    </v-layout>
</template>

<script>
    import ClassroomService from "@/services/ClassroomService";

    export default {
        name: "Teachers",
        components: {},
        data() {
            return {
                searchText: null,
                highlightDevice: null,
                loading: false,
                loadingTime: 1000,
                deleteDialog: false,
                createClassroomDialog: false,
                selectedId: null,
                allItems:[],
                rows:[10,20,50,150,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                pagination: {},
                total: 0,
                lastPage: 1,
                form: {
                    name: null,
                    description: null,
                    alias: null,
                },
            };
        },
        watch: {
            pagination: {
                handler () {
                    // if(this.pagination.page == 1 && this.lastPage == 1) {
                    //     console.log("First page handler");
                    //     this.getAll();
                    // } else if(this.pagination.page < this.lastPage)  {
                    //     this.getPrev();
                    // } else {
                    //     this.getMore();
                    // }
                },
                deep: true
            },
            async searchText(){
                try {
                    var color = "info";
                    // this.loading=true;
                    // console.log('Search Watch');
                    // console.log(this.searchText);
                    // const response = await InteractionService.getAll("", "", this.pagination.rowsPerPage, this.searchText);
                    // console.log(response);
                    // if (response.data.code > 200) {
                    //     color = "warning";
                    // } else if (response.data.result == 2000) {
                    //     this.$store.dispatch("setInteractions", response.data.data);
                    //     this.allItems=response.data.data;
                    //     this.total = response.data.total;
                    //     // this.convertDate()
                    // }
                    // this.loading = false;
                    // this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occurred", color: "error", x: "left", timeout: 3000});
                }
            }
        },
        mounted() {
            this.getAll();
        },
        methods: {
            async createCourse(){
                try {
                    let color = "info";
                    this.loading = true;
                    console.log("Creating Course: ", this.form);

                    const response = await ClassroomService.create(this.form);

                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        // this.$store.dispatch("setInteractions", response.data.data);
                        // this.allItems=response.data.data;
                        // this.total = response.data.total;
                        // this.convertDate()
                        console.log("Successful Process");
                    }
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});

                }catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
                this.createClassroomDialog = false;
            },
            getPrev() {
                // var start = this.pagination.page * this.pagination.rowsPerPage -1;
                // var end = this.pagination.rowsPerPage + start;
                // this.allItems = this.$store.state.interaction.creditNote.records.slice(start, end);
                var end = this.pagination.page * this.pagination.rowsPerPage - 1;
                // var end = this.pagination.rowsPerPage + start;
                var start = (this.pagination.page * this.pagination.rowsPerPage) - this.pagination.rowsPerPage;
                this.allItems = this.$store.state.interaction.notes.records.slice(start, end);
            },

            deletePrompt: function(note){
                this.selectedId = note.id;
                this.deleteDialog = true;
            },
            async getAll() {
                try {
                    // console.log("User info: ", this.$store.state.auth.user);
                    this.loading = true;
                    console.log("Inside GetAll");
                    var color = "info";
                    const response = await ClassroomService.getCourseTeachers();
                    // var response;
                    if(this.$store.state.auth.user.role === 2){
                        console.log("Regular admin found: ", this.$store.state.auth.user.email);
                        // response = await InteractionService.adminAll("", "", this.pagination.rowsPerPage, "", this.$store.state.auth.user.id);
                    } else {
                        console.log("Super Admin: ",  this.$store.state.auth.user.email);
                        // response = await InteractionService.getAll("", "", this.pagination.rowsPerPage, "");
                    }

                    // const customerResponse = await CustomerService.getAll("", "", this.pagination.rowsPerPage, "");
                    console.log(response);
                    // console.log(customerResponse);
                    // this.$store.dispatch("setCustomers", customerResponse.data.data);
                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000 && response.data.data) {
                        this.$store.dispatch("setInteractions", response.data.data);
                        this.allItems = response.data.data;
                        // this.total = response.data.total;
                        // console.log("totals", this.total);
                        this.loading = false;
                        // this.convertDate();
                    }
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: response.data.message,
                        color: color,
                        x: "left",
                        timeout: 3000
                    });
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: "Error occured",
                        color: "error",
                        x: "left",
                        timeout: 3000
                    });
                }
            },
            async update(){
                try {
                    this.loading = true;
                    console.log("Inside GetAll");
                    var color = "info";
                    const response = await ClassroomService.UpdateCourseTeachers();

                    console.log(response);

                    if (response.data.code > 200) {
                        color = "warning";
                        this.loading = false;
                    } else if (response.data.result == 2000 && response.data.data) {
                        this.$store.dispatch("setInteractions", response.data.data);
                        this.allItems = response.data.data;

                        this.loading = false;
                        // this.convertDate();
                    }
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: response.data.message,
                        color: color,
                        x: "left",
                        timeout: 3000
                    });
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: "Error occured",
                        color: "error",
                        x: "left",
                        timeout: 3000
                    });
                }
            },
            async getMore() {
                try {
                    var color = "info";
                    var response;
                    if(this.$store.state.auth.user.role === 2){
                        console.log("Regular admin found: ", this.$store.state.auth.user.email);
                        response = await InteractionService.adminAll(this.allItems[this.allItems.length - 1].id,
                            (new Date(this.allItems[this.allItems.length - 1].created_time).getTime() / 1000), this.pagination.rowsPerPage, "", this.$store.state.auth.user.id);
                    } else {
                        console.log("Super Admin: ",  this.$store.state.auth.user.email);
                        response = await InteractionService.getAll(this.allItems[this.allItems.length - 1].id,
                            (new Date(this.allItems[this.allItems.length - 1].created_time).getTime() / 1000), this.pagination.rowsPerPage, "");
                    }

                    // const response = await InteractionService.getAll(this.allItems[this.allItems.length - 1].id,
                    //     (new Date(this.allItems[this.allItems.length - 1].created_time).getTime() / 1000), this.pagination.rowsPerPage, "");
                    console.log("getmore response: ", response);
                    console.log("get-more last: ", this.allItems[this.allItems.length - 1]);
                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000 && response.data.data) {
                        this.$store.dispatch("setInteractions", this.$store.state.interaction.notes.records.concat(response.data.data));
                        this.allItems = response.data.data;
                        this.lastPage++;
                        // this.convertDate();
                    }
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: response.data.message,
                        color: color,
                        x: "left",
                        timeout: 3000
                    });
                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: "Error occured",
                        color: "error",
                        x: "left",
                        timeout: 3000
                    });
                }
            },
            convertDate: function (){
                var date = null;
                var date2= null;
                for (var i=0; i<this.allItems.length;i++){
                    date = this.allItems[i].start.split('T');
                    date2 = this.allItems[i].end.split('T');
                    this.allItems[i].start=date[0];
                    this.allItems[i].end=date2[0]
                }
            },
        }
    };
</script>

<style scoped>

</style>